import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "ModalHumanChat" */ /* webpackPrefetch: true */
      './ModalHumanChat.component'
    ),
);
